import classNames from 'classnames/bind';
import Emissions from 'common/emissions';
import { IGroupedPromotion } from 'common/promotion';
import { IKeyStringValue } from 'common/types';
import { useCurationContext } from 'contexts/curation';
import { Modal, ModalFuncContext, ModalPosition } from 'contexts/modalFunc';
import Airlines from 'list/common/airline/airlines';
import PromotionInfo from 'list/common/promotionInfo';
import { SyntheticEvent, useContext } from 'react';
import styles from './index.module.scss';
import PromotionBadge from './promotionBadge';

const cx = classNames.bind(styles);

const ItemHeader = ({
  airlines,
  avs,
  carbonEmission,
  carbonEmissionAverage,
  fareType,
  isDirectPromotion,
  oavs,
  otherItems,
  promotion,
  sch,
}: {
  airlines: IKeyStringValue;
  avs: string[];
  carbonEmission?: number;
  carbonEmissionAverage?: number;
  fareType: string;
  isDirectPromotion?: boolean;
  oavs?: string[];
  otherItems?: string[];
  promotion?: IGroupedPromotion;
  sch: string;
}) => {
  const setModal = useContext(ModalFuncContext);
  const {
    isMinDuration,
    isMinPrice,
    isNonstopMinPrice,
    isTopBooking,
    isTopClick,
  } = useCurationContext();
  const isNPayPromotion = !!(isDirectPromotion && promotion);

  const showOtherItem = () => {
    if (sch) {
      setModal({
        type: Modal.SIMILAR,
        position: ModalPosition.LIST,
        payload: { samePriceOrgSch: sch },
      });
    }
  };

  return (
    <div className={cx('ItemHeader')}>
      <div role="row">
        <div className={cx('labels')} itemProp="description">
          {isTopBooking(sch) && (
            <i className={cx('label')} data-type="1">
              예약 많은
            </i>
          )}
          {isTopClick(sch) && (
            <i className={cx('label')} data-type="2">
              많이 찾는
            </i>
          )}
          {isMinPrice(sch) && (
            <i className={cx('label')} data-type="3">
              최저가
            </i>
          )}
          {!isMinPrice(sch) && isNonstopMinPrice(sch) && (
            <i className={cx('label')} data-type="3">
              직항 최저가
            </i>
          )}
          {isMinDuration(sch) && (
            <i className={cx('label')} data-type="4">
              최단 비행시간
            </i>
          )}
        </div>
        {carbonEmissionAverage && (
          <div className={cx('emission')}>
            <Emissions
              clickCodePrefix="isr"
              carbonEmission={carbonEmission}
              carbonEmissionAverage={carbonEmissionAverage}
            />
          </div>
        )}
        <hr />
        {otherItems?.length ? (
          <button
            type="button"
            className={cx('other_schedules')}
            data-event-nlog="click"
            data-event-area-code="isr.subopen"
            itemProp="additionalType"
            onClick={showOtherItem}
          >
            <span className={cx('txt')}>동일가 다른 일정</span>
            <i className={cx('count')}>{otherItems.length}</i>
          </button>
        ) : null}
      </div>
      <div role="row">
        <Airlines avs={avs} airlines={airlines}>
          {isDirectPromotion ? (
            <PromotionBadge />
          ) : (
            isNPayPromotion && (
              <PromotionBadge>
                <PromotionInfo
                  npayIcon={<i className="npaypoint" title="npaypoint" />}
                  paymentMethod={
                    promotion.paymentMethod && fareType.split('/')[1]
                  }
                  summaryByType={promotion.summaryByType}
                />
              </PromotionBadge>
            )
          )}
        </Airlines>
        <hr />
        {oavs && oavs.length > 0 && (
          <sub className={cx('oavs')}>
            {airlines[oavs[0]]
              ? `${airlines[oavs[0]]}${oavs.length > 1 ? ' 등' : ''} 공동운항`
              : '공동운항 정보확인필요'}
          </sub>
        )}
      </div>
    </div>
  );
};

export default ItemHeader;
